import React from 'react';
import { connect } from 'react-redux';
import styled from "styled-components";
import CaseMenuBar from "../tabs/CaseMenuTabs";
import CaseContent from '../../containers/CaseContent';

const Wrapper = styled.div`
   background: #fff;
   display: flex;
   width: 100%;
   border-bottom: 1px solid #ECECEC;
`;

const ContentWrapper = styled.div`
   max-height: 90vh;
   overflow-y: hidden; 
   margin-top: 10px;
`;


const CaseContentWrapper = ({ selectedCaseId, isValidation }) => {
  return (
    <React.Fragment>
      {!isValidation && (
        <Wrapper>
          <CaseMenuBar key={selectedCaseId} />
        </Wrapper>
      )
      }

      <ContentWrapper>
        <CaseContent isValidation={isValidation} />
      </ContentWrapper>
    </React.Fragment>
  );
};

const mapStateToProps = ({ _case: { selectedCase: { id } } }) => ({ selectedCaseId: id });
export default connect(mapStateToProps)(CaseContentWrapper);
